// Mod_Room.ts — the Room modifier (Buildings Set1, §2.4).
//
// A Room is a single space within a Level's subtree. Its footprint comes from the host
// `MapObject`'s authored geometry via `shapeSource` (basic shape / mesh / path). Rooms sit on
// level's `floorTopZ`.
//
// Wall-placement convention (Buildings Set2 §2): the room outline is the wall CENTERLINE — the wall
// solid spans `[outline − wallThickness/2, outline + wallThickness/2]`, so a 10 ft × 10 ft room has
// a 9 ft × 9 ft interior and a 10 ft × 10 ft exterior footprint (with the hardcoded 0.2 m wall),
// and the wall thickness can be retuned without moving any room. Under Set1 the outline was the
// INTERIOR face and the wall grew outward by the full thickness.
import {BuildingMaterials, ShapeSourceRef} from "./Building/BuildingShared.js";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export enum RoomRoofContribution { auto = "auto", none = "none" }

export class Mod_Room {
	constructor(data?: Partial<Mod_Room>) { Object.assign(this, data); }

	/** Null => auto: basic shape if `shape_type` set, else first mesh, else first path. */
	shapeSource?: n|ShapeSourceRef;

	/** Wall thickness in metres, measured across the wall (the outline is the centerline). Set2
	 *  §4.1: inherits from `Mod_Level.wallThickness` when unset. */
	wallThickness?: number|n;
	/** Per-room overrides of the level's values (rare, but e.g. a double-height atrium). */
	floorThickness?: number|n;
	wallHeight?: number|n;

	hasFloor?: boolean|n;
	hasCeiling?: boolean|n;
	/** "none" excludes this room from the Building roof union (covered porches, light wells). */
	roofContribution?: RoomRoofContribution|n;

	materials?: n|BuildingMaterials;
}
